module.exports = __webpack_public_path__ + "img/import_icon.5402eab1.png";